import { cn } from '@commenda/utils';
import { Button } from '../../Button';
import type { TableErrorConfig } from '../types';

interface TableErrorProps {
  columnsLength: number;
  errorConfig: TableErrorConfig;
  className?: string;
}

export function TableError({
  columnsLength,
  errorConfig,
  className,
}: TableErrorProps) {
  const { title, description, action, secondaryAction } = errorConfig;

  return (
    <tr className={cn('relative', className)}>
      <td colSpan={columnsLength} className="h-[320px] p-0 relative">
        <div className="absolute inset-0 w-full bg-bg-secondary flex items-center justify-center">
          <div className="flex flex-col items-center w-full gap-5 px-xl py-6 max-w-[354px]">
            <div className="text-center">
              <h3 className="txt-medium-bold text-text-primary mb-1">
                {title}
              </h3>
              <div className="txt-small-regular text-text-secondary">
                {typeof description === 'string' ? (
                  <p>{description}</p>
                ) : (
                  description
                )}
              </div>
            </div>

            {(action || errorConfig.secondaryAction) && (
              <div className="flex gap-4 items-center">
                {action && (
                  <Button
                    variant="secondary"
                    onClick={action.onClick}
                    size="sm"
                  >
                    {action.text}
                  </Button>
                )}
                {secondaryAction && (
                  <Button
                    variant="tertiary"
                    onClick={secondaryAction.onClick}
                    size="sm"
                  >
                    {secondaryAction.text}
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
      </td>
    </tr>
  );
}
